// import logo from './logo.svg';
import React from 'react'
import { Route, Routes } from 'react-router-dom';
import { Landing, Navbar, Register, Profile, Course, Contact } from './components';
import Success from './components/mercadopago/Success';
import Failure from './components/mercadopago/Failure';
import Pending from './components/mercadopago/Pending';
import AdminApp from './AdminApp';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css'
import useManteinSession  from './hooks/useManteinSession';


function App() {
  useManteinSession();
  return (
    <div className="App">
      <header className="App-header">
        <Navbar />
      </header>
      <div>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Register />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/course/:id' element={<Course />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/admin/*' element={<AdminApp />} />
          {/* <Route path="*" element={<NotFoundPage />} /> */}
          <Route path='/success' element={<Success />} />
          <Route path='/failure' element={<Failure />} />
          <Route path='/pending' element={<Pending />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
